// Email verification constants
export const VERIFICATION_CODE_LENGTH = 6
export const RESEND_COOLDOWN_TIME = 60 // seconds

// UI constants
export const LOADING_SPINNER_SIZE = 'lg'
export const FORM_BUTTON_SIZE = 'md'

// Error messages
export const ERROR_MESSAGES = {
  CAPTCHA_REQUIRED: 'Please complete the captcha verification.',
  CAPTCHA_ERROR: 'There was an issue with the captcha. Please try again.',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  EMAIL_MISMATCH: 'Email addresses do not match',
  CONFIRM_EMAIL_REQUIRED: 'Please confirm your email address',
  ORG_NAME_TOO_SHORT: 'Organization name must be at least 2 characters',
  CONTACT_NAME_TOO_SHORT: 'Contact name must be at least 2 characters',
  VERIFICATION_CODE_LENGTH: `Code must be ${VERIFICATION_CODE_LENGTH} digits`,
} as const

// Success messages
export const SUCCESS_MESSAGES = {
  ACCOUNT_CREATED: 'Account initiated successfully. Please check your email for a verification code.',
  EMAIL_VERIFIED: 'Email verified successfully!',
  CODE_RESENT: 'Verification code sent successfully!',
} as const

// Form validation
export const MIN_NAME_LENGTH = 2
